export default [
    {
       "language":"af",
       "name":"Afrikaans",
       "emoji":"🇿🇦"
    },
    {
       "language":"ak",
       "name":"Akan",
       "emoji":"🇬🇭"
    },
    {
       "language":"sq",
       "name":"Albanian",
       "emoji":"🇦🇱"
    },
    {
       "language":"am",
       "name":"Amharic",
       "emoji":"🇪🇹"
    },
    {
       "language":"ar",
       "name":"Arabic",
       "emoji":"🇸🇦"
    },
    {
       "language":"hy",
       "name":"Armenian",
       "emoji":"🇦🇲"
    },
    {
       "language":"as",
       "name":"Assamese",
       "emoji":"🇮🇳"
    },
    {
       "language":"ay",
       "name":"Aymara",
       "emoji":"🇧🇴"
    },
    {
       "language":"az",
       "name":"Azerbaijani",
       "emoji":"🇦🇿"
    },
    {
       "language":"bm",
       "name":"Bambara",
       "emoji":"🇲🇱"
    },
    {
       "language":"eu",
       "name":"Basque",
       "emoji":"🇪🇸"
    },
    {
       "language":"be",
       "name":"Belarusian",
       "emoji":"🇧🇾"
    },
    {
       "language":"bn",
       "name":"Bengali",
       "emoji":"🇧🇩"
    },
    {
       "language":"bho",
       "name":"Bhojpuri",
       "emoji":"🇮🇳"
    },
    {
       "language":"bs",
       "name":"Bosnian",
       "emoji":"🇧🇦"
    },
    {
       "language":"bg",
       "name":"Bulgarian",
       "emoji":"🇧🇬"
    },
    {
       "language":"ca",
       "name":"Catalan",
       "emoji":"🇪🇸"
    },
    {
       "language":"ceb",
       "name":"Cebuano",
       "emoji":"🇵🇭"
    },
    {
       "language":"ny",
       "name":"Chichewa",
       "emoji":"🇲🇼"
    },
    {
       "language":"zh",
       "name":"Chinese (Simplified)",
       "emoji":"🇨🇳"
    },
    {
       "language":"zh-tw",
       "name":"Chinese (Traditional)",
       "emoji":"🇹🇼"
    },
    {
       "language":"co",
       "name":"Corsican",
       "emoji":"🇫🇷"
    },
    {
       "language":"hr",
       "name":"Croatian",
       "emoji":"🇭🇷"
    },
    {
       "language":"cs",
       "name":"Czech",
       "emoji":"🇨🇿"
    },
    {
       "language":"da",
       "name":"Danish",
       "emoji":"🇩🇰"
    },
    {
       "language":"dv",
       "name":"Divehi",
       "emoji":"🇲🇻"
    },
    {
       "language":"doi",
       "name":"Dogri",
       "emoji":"🇮🇳"
    },
    {
       "language":"nl",
       "name":"Dutch",
       "emoji":"🇳🇱"
    },
    {
       "language":"en",
       "name":"English",
       "emoji":"🇬🇧"
    },
    {
       "language":"eo",
       "name":"Esperanto",
       "emoji":"🌍"
    },
    {
       "language":"et",
       "name":"Estonian",
       "emoji":"🇪🇪"
    },
    {
       "language":"ee",
       "name":"Ewe",
       "emoji":"🇹🇬"
    },
    {
       "language":"tl",
       "name":"Filipino",
       "emoji":"🇵🇭"
    },
    {
       "language":"fi",
       "name":"Finnish",
       "emoji":"🇫🇮"
    },
    {
       "language":"fr",
       "name":"French",
       "emoji":"🇫🇷"
    },
    {
       "language":"fy",
       "name":"Frisian",
       "emoji":"🇳🇱"
    },
    {
       "language":"gl",
       "name":"Galician",
       "emoji":"🇪🇸"
    },
    {
       "language":"lg",
       "name":"Ganda",
       "emoji":"🇺🇬"
    },
    {
       "language":"ka",
       "name":"Georgian",
       "emoji":"🇬🇪"
    },
    {
       "language":"de",
       "name":"German",
       "emoji":"🇩🇪"
    },
    {
       "language":"gom",
       "name":"Goan Konkani",
       "emoji":"🇮🇳"
    },
    {
       "language":"el",
       "name":"Greek",
       "emoji":"🇬🇷"
    },
    {
       "language":"gn",
       "name":"Guarani",
       "emoji":"🇵🇾"
    },
    {
       "language":"gu",
       "name":"Gujarati",
       "emoji":"🇮🇳"
    },
    {
       "language":"ht",
       "name":"Haitian Creole",
       "emoji":"🇭🇹"
    },
    {
       "language":"ha",
       "name":"Hausa",
       "emoji":"🇳🇬"
    },
    {
       "language":"haw",
       "name":"Hawaiian",
       "emoji":"🇺🇸"
    },
    {
       "language":"iw",
       "name":"Hebrew",
       "emoji":"🇮🇱"
    },
    {
       "language":"hi",
       "name":"Hindi",
       "emoji":"🇮🇳"
    },
    {
       "language":"hmn",
       "name":"Hmong",
       "emoji":"🇨🇳"
    },
    {
       "language":"hu",
       "name":"Hungarian",
       "emoji":"🇭🇺"
    },
    {
       "language":"is",
       "name":"Icelandic",
       "emoji":"🇮🇸"
    },
    {
       "language":"ig",
       "name":"Igbo",
       "emoji":"🇳🇬"
    },
    {
       "language":"ilo",
       "name":"Iloko",
       "emoji":"🇵🇭"
    },
    {
       "language":"id",
       "name":"Indonesian",
       "emoji":"🇮🇩"
    },
    {
       "language":"ga",
       "name":"Irish",
       "emoji":"🇮🇪"
    },
    {
       "language":"it",
       "name":"Italian",
       "emoji":"🇮🇹"
    },
    {
       "language":"ja",
       "name":"Japanese",
       "emoji":"🇯🇵"
    },
    {
       "language":"jw",
       "name":"Javanese",
       "emoji":"🇮🇩"
    },
    {
       "language":"kn",
       "name":"Kannada",
       "emoji":"🇮🇳"
    },
    {
       "language":"kk",
       "name":"Kazakh",
       "emoji":"🇰🇿"
    },
    {
       "language":"km",
       "name":"Khmer",
       "emoji":"🇰🇭"
    },
    {
       "language":"rw",
       "name":"Kinyarwanda",
       "emoji":"🇷🇼"
    },
    {
       "language":"ko",
       "name":"Korean",
       "emoji":"🇰🇷"
    },
    {
       "language":"kri",
       "name":"Krio",
       "emoji":"🇸🇱"
    },
    {
       "language":"ku",
       "name":"Kurdish (Kurmanji)",
       "emoji":"🇰🇼"
    },
    {
       "language":"ckb",
       "name":"Kurdish (Sorani)",
       "emoji":"🇮🇶"
    },
    {
       "language":"ky",
       "name":"Kyrgyz",
       "emoji":"🇰🇬"
    },
    {
       "language":"lo",
       "name":"Lao",
       "emoji":"🇱🇦"
    },
    {
       "language":"la",
       "name":"Latin",
       "emoji":"🏴"
    },
    {
       "language":"lv",
       "name":"Latvian",
       "emoji":"🇱🇻"
    },
    {
       "language":"ln",
       "name":"Lingala",
       "emoji":"🇨🇩"
    },
    {
       "language":"lt",
       "name":"Lithuanian",
       "emoji":"🇱🇹"
    },
    {
       "language":"lb",
       "name":"Luxembourgish",
       "emoji":"🇱🇺"
    },
    {
       "language":"mk",
       "name":"Macedonian",
       "emoji":"🇲🇰"
    },
    {
       "language":"mai",
       "name":"Maithili",
       "emoji":"🇮🇳"
    },
    {
       "language":"mg",
       "name":"Malagasy",
       "emoji":"🇲🇬"
    },
    {
       "language":"ms",
       "name":"Malay",
       "emoji":"🇲🇾"
    },
    {
       "language":"ml",
       "name":"Malayalam",
       "emoji":"🇮🇳"
    },
    {
       "language":"mt",
       "name":"Maltese",
       "emoji":"🇲🇹"
    },
    {
       "language":"mni-mtei",
       "name":"Manipuri (Meitei Mayek)",
       "emoji":"🇮🇳"
    },
    {
       "language":"mi",
       "name":"Maori",
       "emoji":"🇳🇿"
    },
    {
       "language":"mr",
       "name":"Marathi",
       "emoji":"🇮🇳"
    },
    {
       "language":"lus",
       "name":"Mizo",
       "emoji":"🇮🇳"
    },
    {
       "language":"mn",
       "name":"Mongolian",
       "emoji":"🇲🇳"
    },
    {
       "language":"my",
       "name":"Myanmar (Burmese)",
       "emoji":"🇲🇲"
    },
    {
       "language":"ne",
       "name":"Nepali",
       "emoji":"🇳🇵"
    },
    {
       "language":"nso",
       "name":"Northern Sotho",
       "emoji":"🇿🇦"
    },
    {
       "language":"no",
       "name":"Norwegian",
       "emoji":"🇳🇴"
    },
    {
       "language":"or",
       "name":"Odia (Oriya)",
       "emoji":"🇮🇳"
    },
    {
       "language":"om",
       "name":"Oromo",
       "emoji":"🇪🇹"
    },
    {
       "language":"ps",
       "name":"Pashto",
       "emoji":"🇦🇫"
    },
    {
       "language":"fa",
       "name":"Persian",
       "emoji":"🇮🇷"
    },
    {
       "language":"pl",
       "name":"Polish",
       "emoji":"🇵🇱"
    },
    {
       "language":"pt",
       "name":"Portuguese",
       "emoji":"🇵🇹"
    },
    {
       "language":"pa",
       "name":"Punjabi",
       "emoji":"🇮🇳"
    },
    {
       "language":"qu",
       "name":"Quechua",
       "emoji":"🇵🇪"
    },
    {
       "language":"ro",
       "name":"Romanian",
       "emoji":"🇷🇴"
    },
    {
       "language":"ru",
       "name":"Russian",
       "emoji":"🇷🇺"
    },
    {
       "language":"sm",
       "name":"Samoan",
       "emoji":"🇼🇸"
    },
    {
       "language":"sa",
       "name":"Sanskrit",
       "emoji":"🇮🇳"
    },
    {
       "language":"gd",
       "name":"Scots Gaelic",
       "emoji":"🏴󠁧󠁢󠁳󠁣󠁴󠁿"
    },
    {
       "language":"sr",
       "name":"Serbian",
       "emoji":"🇷🇸"
    },
    {
       "language":"st",
       "name":"Sesotho",
       "emoji":"🇱🇸"
    },
    {
       "language":"sn",
       "name":"Shona",
       "emoji":"🇿🇼"
    },
    {
       "language":"sd",
       "name":"Sindhi",
       "emoji":"🇵🇰"
    },
    {
       "language":"si",
       "name":"Sinhala",
       "emoji":"🇱🇰"
    },
    {
       "language":"sk",
       "name":"Slovak",
       "emoji":"🇸🇰"
    },
    {
       "language":"sl",
       "name":"Slovenian",
       "emoji":"🇸🇮"
    },
    {
       "language":"so",
       "name":"Somali",
       "emoji":"🇸🇴"
    },
    {
       "language":"es",
       "name":"Spanish",
       "emoji":"🇪🇸"
    },
    {
       "language":"su",
       "name":"Sundanese",
       "emoji":"🇮🇩"
    },
    {
       "language":"sw",
       "name":"Swahili",
       "emoji":"🇹🇿"
    },
    {
       "language":"sv",
       "name":"Swedish",
       "emoji":"🇸🇪"
    },
    {
       "language":"tg",
       "name":"Tajik",
       "emoji":"🇹🇯"
    },
    {
       "language":"ta",
       "name":"Tamil",
       "emoji":"🇮🇳"
    },
    {
       "language":"tt",
       "name":"Tatar",
       "emoji":"🇹🇲"
    },
    {
       "language":"te",
       "name":"Telugu",
       "emoji":"🇮🇳"
    },
    {
       "language":"th",
       "name":"Thai",
       "emoji":"🇹🇭"
    },
    {
       "language":"ti",
       "name":"Tigrinya",
       "emoji":"🇪🇷"
    },
    {
       "language":"ts",
       "name":"Tsonga",
       "emoji":"🇿🇦"
    },
    {
       "language":"tr",
       "name":"Turkish",
       "emoji":"🇹🇷"
    },
    {
       "language":"tk",
       "name":"Turkmen",
       "emoji":"🇹🇲"
    },
    {
       "language":"uk",
       "name":"Ukrainian",
       "emoji":"🇺🇦"
    },
    {
       "language":"ur",
       "name":"Urdu",
       "emoji":"🇵🇰"
    },
    {
       "language":"ug",
       "name":"Uyghur",
       "emoji":"🇨🇳"
    },
    {
       "language":"uz",
       "name":"Uzbek",
       "emoji":"🇺🇿"
    },
    {
       "language":"vi",
       "name":"Vietnamese",
       "emoji":"🇻🇳"
    },
    {
       "language":"cy",
       "name":"Welsh",
       "emoji":"🏴󠁧󠁢󠁷󠁬󠁳󠁿"
    },
    {
       "language":"xh",
       "name":"Xhosa",
       "emoji":"🇿🇦"
    },
    {
       "language":"yi",
       "name":"Yiddish",
       "emoji":"🇮🇱"
    },
    {
       "language":"yo",
       "name":"Yoruba",
       "emoji":"🇳🇬"
    },
    {
       "language":"zu",
       "name":"Zulu",
       "emoji":"🇿🇦"
    },
    {
       "language":"he",
       "name":"Hebrew",
       "emoji":"🇮🇱"
    },
    {
       "language":"jv",
       "name":"Javanese",
       "emoji":"🇮🇩"
    },
    {
       "language":"zh-cn",
       "name":"Chinese (Simplified)",
       "emoji":"🇨🇳"
    }
 ]